import Cookies from 'js-cookie';
import React, { useEffect, createContext, useContext, useState } from 'react';
import { GlobalCfg } from './conf';
import { postMessageAction, postMessageService } from './app/shared/postMessageService';
import { IS_BREADCRUMB_HIDDEN_PARAM } from './app/search/AppBreadcrumbs';

const ACCESSIBILITY_LOADED = 'ACCESSIBILITY_LOADED';
const LOGOUT = 'LOGOUT';
const AccessibilityContext = createContext(false);

// This component listens for messages from the parent window to toggle high contrast mode.
const AccessibilityHandler: React.FC = ({ children }: any) => {
    const [isAccessibilityEnabled, setIsAccessibilityEnabled] = useState(false);

    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            // Check if the message is from the parent window
            if (event.data.type === ACCESSIBILITY_LOADED) {
                const { isAccessibilityOn } = event.data;

                // Add high contrast class to body if accessibility is enabled
                if (isAccessibilityOn) {
                    document.body.classList.add('f-high-contrast');
                } else {
                    document.body.classList.remove('f-high-contrast');
                }

                // Set the accessibility state
                setIsAccessibilityEnabled(isAccessibilityOn);
            }
            if (event.data.type === LOGOUT) {
                const searchParams = new URLSearchParams(window.location.search);
                const isFromSetting = searchParams.get(IS_BREADCRUMB_HIDDEN_PARAM);

                const message = {
                    action: postMessageAction.REAUTHENTICATE_AND_REDIRECT,
                    url: window.location.href,
                    isFromSetting,
                };
                postMessageService.sendToParent(message);
                Cookies.remove(GlobalCfg.CLIENT_AUTH_COOKIE);
            }
        };

        // Add listener using the postMessage service
        window.addEventListener('message', handleMessage);

        // Cleanup listener on unmount
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    // Provide the accessibility state to the children
    return <AccessibilityContext.Provider value={isAccessibilityEnabled}>{children}</AccessibilityContext.Provider>;
};

export default AccessibilityHandler;

// Custom hook to use accessibility context
export const useAccessibility = () => {
    return useContext(AccessibilityContext);
};
